const emailTemplates = {};

emailTemplates["default"] = {
    name:"Osallistumislinkki peliin, saateteksti", 
    index: 1,
    template: 
// ==================== JSON START =========================================
        {
            "counters":{
               "u_row":1,
               "u_content_text":2,
               "u_content_image":1,
               "u_content_divider":1,
               "u_column":1,
               "u_content_html":1
            },
            "body":{
               "rows":[
                  {
                     "cells":[
                        1
                     ],
                     "columns":[
                        {
                           "contents":[
                              {
                                 "type":"image",
                                 "values":{
                                    "containerPadding":"10px",
                                    "src":{
                                       "url":"https://unroll-images-production.s3.amazonaws.com/projects/0/1639580989422-FriCo-logo-app-colormatched.svg",
                                       "width":275,
                                       "height":150
                                    },
                                    "textAlign":"center",
                                    "altText":"",
                                    "action":{
                                       "name":"web",
                                       "values":{
                                          "href":"",
                                          "target":"_blank"
                                       }
                                    },
                                    "hideDesktop":false,
                                    "_meta":{
                                       "htmlClassNames":"u_content_image",
                                       "htmlID":"u_content_image_1"
                                    },
                                    "selectable":true,
                                    "draggable":true,
                                    "duplicatable":true,
                                    "deletable":true,
                                    "hideable":true
                                 }
                              },
                              {
                                 "type":"text",
                                 "values":{
                                    "containerPadding":"10px",
                                    "textAlign":"left",
                                    "lineHeight":"140%",
                                    "linkStyle":{
                                       "inherit":true,
                                       "linkColor":"#0000ee",
                                       "linkHoverColor":"#0000ee",
                                       "linkUnderline":true,
                                       "linkHoverUnderline":true
                                    },
                                    "hideDesktop":false,
                                    "_meta":{
                                       "htmlClassNames":"u_content_text",
                                       "htmlID":"u_content_text_1"
                                    },
                                    "selectable":true,
                                    "draggable":true,
                                    "duplicatable":true,
                                    "deletable":true,
                                    "hideable":true,
                                    "text":"<p style=\"font-size: 14px; line-height: 140%;\">Hei,</p>\n<p style=\"font-size: 14px; line-height: 140%;\">&nbsp;</p>\n<p style=\"font-size: 14px; line-height: 140%;\">olet mukana peliss&auml;, olethan siis kuulolla.&nbsp;</p>\n<p style=\"font-size: 14px; line-height: 140%;\">&nbsp;</p>\n<p style=\"font-size: 14px; line-height: 140%;\">Terveisin&nbsp;</p>\n<p style=\"font-size: 14px; line-height: 140%;\">Frico&ndash;pelitiimi</p>"
                                 }
                              },
                              {
                                 "type":"divider",
                                 "values":{
                                    "width":"100%",
                                    "border":{
                                       "borderTopWidth":"1px",
                                       "borderTopStyle":"solid",
                                       "borderTopColor":"#BBBBBB"
                                    },
                                    "textAlign":"center",
                                    "containerPadding":"10px",
                                    "hideDesktop":false,
                                    "_meta":{
                                       "htmlID":"u_content_divider_1",
                                       "htmlClassNames":"u_content_divider"
                                    },
                                    "selectable":true,
                                    "draggable":true,
                                    "duplicatable":true,
                                    "deletable":true,
                                    "hideable":true
                                 }
                              },
                              {
                                 "type":"html",
                                 "values":{
                                    "html":"<div style=\"text-align: center\">\n<a href=\"https://www.ahaavision.com\">Ahaa Vision Oy</a>\n</div>",
                                    "containerPadding":"10px",
                                    "_meta":{
                                       "htmlID":"u_content_html_1",
                                       "htmlClassNames":"u_content_html"
                                    },
                                    "selectable":true,
                                    "draggable":true,
                                    "duplicatable":true,
                                    "deletable":true,
                                    "hideable":true
                                 }
                              }
                           ],
                           "values":{
                              "padding":"0px",
                              "_meta":{
                                 "htmlID":"u_column_1",
                                 "htmlClassNames":"u_column"
                              },
                              "border":{
                                 
                              },
                              "backgroundColor":""
                           }
                        }
                     ],
                     "values":{
                        "displayCondition":null,
                        "columns":false,
                        "backgroundColor":"",
                        "columnsBackgroundColor":"",
                        "backgroundImage":{
                           "url":"",
                           "fullWidth":true,
                           "repeat":false,
                           "center":true,
                           "cover":false
                        },
                        "padding":"0px",
                        "hideDesktop":false,
                        "_meta":{
                           "htmlClassNames":"u_row",
                           "htmlID":"u_row_1"
                        },
                        "selectable":true,
                        "draggable":true,
                        "duplicatable":true,
                        "deletable":true,
                        "hideable":true
                     }
                  }
               ],
               "values":{
                  "textColor":"#000000",
                  "backgroundColor":"#ffffff",
                  "backgroundImage":{
                     "url":"",
                     "fullWidth":true,
                     "repeat":false,
                     "center":true,
                     "cover":false
                  },
                  "contentWidth":"500px",
                  "contentAlign":"center",
                  "fontFamily":{
                     "label":"Arial",
                     "value":"arial,helvetica,sans-serif"
                  },
                  "preheaderText":"",
                  "linkStyle":{
                     "body":true,
                     "inherit":false,
                     "linkColor":"#236fa1",
                     "linkUnderline":false,
                     "linkHoverColor":"#0000ee",
                     "linkHoverUnderline":true
                  },
                  "_meta":{
                     "htmlClassNames":"u_body",
                     "htmlID":"u_body"
                  }
               }
            },
            "schemaVersion":6
         },
// ==================== JSON END =========================================    
// THE LINE BELOW WILL CONTAIN THE EMAIL CONTENT IN HTML FORMAT
// =======================================================================
    html: `
    <!DOCTYPE HTML PUBLIC "-//W3C//DTD XHTML 1.0 Transitional //EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd"><html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office"><head><!--[if gte mso 9]><xml>  <o:OfficeDocumentSettings>    <o:AllowPNG/>    <o:PixelsPerInch>96</o:PixelsPerInch>  </o:OfficeDocumentSettings></xml><![endif]-->  <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">  <meta name="viewport" content="width=device-width, initial-scale=1.0">  <meta name="x-apple-disable-message-reformatting">  <!--[if !mso]><!--><meta http-equiv="X-UA-Compatible" content="IE=edge"><!--<![endif]-->  <title></title>      <style type="text/css">      table, td { color: #000000; } a { color: #236fa1; text-decoration: none; }@media only screen and (min-width: 520px) {  .u-row {    width: 500px !important;  }  .u-row .u-col {    vertical-align: top;  }  .u-row .u-col-100 {    width: 500px !important;  }}@media (max-width: 520px) {  .u-row-container {    max-width: 100% !important;    padding-left: 0px !important;    padding-right: 0px !important;  }  .u-row .u-col {    min-width: 320px !important;    max-width: 100% !important;    display: block !important;  }  .u-row {    width: calc(100% - 40px) !important;  }  .u-col {    width: 100% !important;  }  .u-col > div {    margin: 0 auto;  }}body {  margin: 0;  padding: 0;}table,tr,td {  vertical-align: top;  border-collapse: collapse;}p {  margin: 0;}.ie-container table,.mso-container table {  table-layout: fixed;}* {  line-height: inherit;}a[x-apple-data-detectors='true'] {  color: inherit !important;  text-decoration: none !important;}</style>    </head><body class="clean-body u_body" style="margin: 0;padding: 0;-webkit-text-size-adjust: 100%;background-color: #ffffff;color: #000000">  <!--[if IE]><div class="ie-container"><![endif]-->  <!--[if mso]><div class="mso-container"><![endif]-->  <table style="border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;min-width: 320px;Margin: 0 auto;background-color: #ffffff;width:100%" cellpadding="0" cellspacing="0">  <tbody>  <tr style="vertical-align: top">    <td style="word-break: break-word;border-collapse: collapse !important;vertical-align: top">    <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td align="center" style="background-color: #ffffff;"><![endif]-->    <div class="u-row-container" style="padding: 0px;background-color: transparent">  <div class="u-row" style="Margin: 0 auto;min-width: 320px;max-width: 500px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: transparent;">    <div style="border-collapse: collapse;display: table;width: 100%;background-color: transparent;">      <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding: 0px;background-color: transparent;" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:500px;"><tr style="background-color: transparent;"><![endif]-->      <!--[if (mso)|(IE)]><td align="center" width="500" style="width: 500px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;" valign="top"><![endif]--><div class="u-col u-col-100" style="max-width: 320px;min-width: 500px;display: table-cell;vertical-align: top;">  <div style="width: 100% !important;">  <!--[if (!mso)&(!IE)]><!--><div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;"><!--<![endif]-->  <table style="font-family:arial,helvetica,sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0">  <tbody>    <tr>      <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif;" align="left">        <table width="100%" cellpadding="0" cellspacing="0" border="0">  <tr>    <td style="padding-right: 0px;padding-left: 0px;" align="center">            <img align="center" border="0" src="https://unroll-images-production.s3.amazonaws.com/projects/0/1639597061951-Asset%202300px.png" alt="" title="" style="outline: none;text-decoration: none;-ms-interpolation-mode: bicubic;clear: both;display: inline-block !important;border: none;height: auto;float: none;width: 100%;max-width: 300px;" width="300"/>          </td>  </tr></table>      </td>    </tr>  </tbody></table><table style="font-family:arial,helvetica,sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0">  <tbody>    <tr>      <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif;" align="left">          <div>    <p>Hei,</p><br/><p>olet mukana pelissä, pääset osallistumaan alla olevan linkin kautta.</p><br/><p><a href="XXXXXX">Osallistu peliin </a></p><br/><p>Terveisin </p><p>FriCo–pelitiimi</p></div>      </td>    </tr>  </tbody></table><table style="font-family:arial,helvetica,sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0">  <tbody>    <tr>      <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif;" align="left">          <table height="0px" align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;border-top: 1px solid #BBBBBB;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%">    <tbody>      <tr style="vertical-align: top">        <td style="word-break: break-word;border-collapse: collapse !important;vertical-align: top;font-size: 0px;line-height: 0px;mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%">          <span>&#160;</span>        </td>      </tr>    </tbody>  </table>      </td>    </tr>  </tbody></table><table style="font-family:arial,helvetica,sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0">  <tbody>    <tr>      <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif;" align="left">          <div>    <div style="text-align: center"><a href="https://www.ahaavision.com">Ahaa Vision Oy</a></div>  </div>      </td>    </tr>  </tbody></table>  <!--[if (!mso)&(!IE)]><!--></div><!--<![endif]-->  </div></div><!--[if (mso)|(IE)]></td><![endif]-->      <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]-->    </div>  </div></div>    <!--[if (mso)|(IE)]></td></tr></table><![endif]-->    </td>  </tr>  </tbody>  </table>  <!--[if mso]></div><![endif]-->  <!--[if IE]></div><![endif]--></body></html>
    `.trim()
};

export const getDefaultTemplate = (option="default")=>{
    return emailTemplates[option];
}
